import { c as _c } from "react/compiler-runtime";
import { BadgePropertiesType } from "@website/ui/badge/badge.types";
import { FC } from "react";
export const Badge: FC<BadgePropertiesType> = properties => {
  const $ = _c(3);
  const {
    content,
    color: t0,
    className
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const t1 = `border-on-color-high-emphasis inline-block size-2 rounded-full border ${color === "primary" ? "bg-primary" : color === "secondary" ? "bg-secondary" : "bg-success"} ${content ? "text-mini-badge text-on-color-high-emphasis flex h-4 w-max min-w-[16px] items-center justify-center px-1 py-[2px]" : ""} ${className ?? ""}`;
  let t2;
  if ($[0] !== content || $[1] !== t1) {
    t2 = <span className={t1}>{content}</span>;
    $[0] = content;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};